<template>
	<Route
		:routes="routes"
		:breadcrumbs="breadcrumbs"
	>
		<template slot="title">
			Super User
		</template>
		<transition
			:name="transition"
			mode="out-in"
		>
			<keep-alive>
				<router-view />
			</keep-alive>
		</transition>
	</Route>
</template>

<script>
import Route from '@/views/layouts/Route';

export default {
	components: {
		Route,
	},
	data() {
		return {
			transition: '',
			breadcrumbs: [
				{ text: 'Dashboard', to: '/' },
				{ text: 'Super User', disabled: true },
			],
			routes: [
				{ name: 'Publications', to: { name: 'Publications' } },
				{ name: 'Parse Article', to: { name: 'ParseArticle' } },
				{ name: 'Accounts', to: { name: 'SuperAccounts' } },
			],
		};
	},
	/** @todo Duplicated in few places, find a way to DRY it out */
	beforeRouteUpdate(to, from, next) {
		const fromIndex = this.routes.findIndex(r => r.to.name === from.name);
		const toIndex = this.routes.findIndex(r => r.to.name === to.name);

		if (fromIndex === toIndex) {
			this.transition = '';
		}
		else if (fromIndex < toIndex) {
			this.transition = 'slide-left';
		}
		else {
			this.transition = 'slide-right';
		}

		next();
	},
};
</script>
